import ElmModal from "../elm_modal"
import initVoucherApp from "../../components/venue/vouchers"
import { logDecodingError } from "../../helpers/airbrake"
import { pushGa4Event } from "../../helpers/ga4_helper"
import { loadBackgroundImages } from "../../helpers/image_loader"
import { ENTRY, prefetchEntry } from "../../helpers/prefetch"
import airbrakeClient from "../../helpers/airbrake"

declare global {
  interface Window {
    elmPackageFlags : Flags
  }
}

const PACKAGE_MODAL_ID = "elm-package-details-modal"

const observePackages = (packagesViewed: PortToElm<null>): void => {
  let portFired = false

  const packagesSection = document.getElementById("packages")
  const statusBar = document.querySelector("[data-status-bar]")

  const observer = new window.IntersectionObserver(entries => {
    entries.forEach(({ isIntersecting }) => {
      statusBar?.classList.toggle("is-hidden", isIntersecting)

      if (isIntersecting && !portFired) {
        packagesViewed.send(null)
        portFired = true
      }
    })
  }, { root: null, rootMargin: "-25% 0px", threshold: 0 })

  if (packagesSection) observer.observe(packagesSection)
}

export default (elmVenue: ElmVenue): void => {
  const packagesNode = document.getElementById("elm-packages")
  if (!packagesNode) return

  const flags = window.elmPackageFlags || {}
  const modal = new ElmModal({ modalId: PACKAGE_MODAL_ID })
  const app = elmVenue.Packages.init({ node: packagesNode, flags })

  app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
  app.ports.modalOpened.subscribe(modal.trapFocus)
  app.ports.pushGa4Event.subscribe(pushGa4Event)
  app.ports.checkAvailability.subscribe(() => prefetchEntry(ENTRY.BOOKINGS))
  app.ports.buyVoucher.subscribe(([packageId, ecommerceItem]: [string, string]) => {
    initVoucherApp({
      elmVenue,
      packageId,
      ecommerceItem,
      bookNowHandler: app.ports.bookFromVoucher
    })
  })
  app.ports.setRoomCarouselFlags.subscribe(carouselFlags => {
    window.roomCarouselFlags = carouselFlags

    // Load fallback images for any rooms without carousel. Such rooms will have appropriate
    // attributes on their respective `data-img` elements instead of a Stimulus carousel controller.
    window.requestAnimationFrame(() => {
      loadBackgroundImages(document.querySelectorAll(`#${PACKAGE_MODAL_ID} [data-img]`))
    })
  })
  app.ports.reportError.subscribe((errors : Array<[string, string]>) => {
    void airbrakeClient.notify({
      error: "No rooms available during checkout",
      params: Object.fromEntries(errors)
    })
  })

  observePackages(app.ports.packagesViewed)
}
